import { render, staticRenderFns } from "./barCode.vue?vue&type=template&id=4be21ece"
import script from "./barCode.vue?vue&type=script&lang=js"
export * from "./barCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports